import {defineStore} from 'pinia'
import DataSource from "devextreme/data/data_source";
import { ref} from "vue";
import {useNaikPangkatListModel} from "@/stores/models/naik-pangkat-list-model";

export const useNaikPangkatListStore  = defineStore(
    'naikPangkatListStore',
    () => {
       
        const isLoading = ref(false);
        const dataSourceNaikPangkatList = ref(
            new DataSource({
                requireTotalCount: true,
                store: useNaikPangkatListModel().naikPangkatListCustomStore,
                filter: null,
            })
        );

         const dataSourceNaikPangkatListSeparated = ref(
            new DataSource({
                requireTotalCount: true,
                store: useNaikPangkatListModel().naikPangkatListCustomStore,
                filter: null,
            })
        );
       
        const loadData = async (filter = null) => {
            isLoading.value = true;
            try {
                dataSourceNaikPangkatList.value.filter(filter);
                // Reload the DataSource with the new filter
                const result = await dataSourceNaikPangkatList.value.load();
                return result;
            } catch (error) {
                console.error("Error loading data:", error);
                throw error;
            } finally {
                isLoading.value = false;
            }
        };

        const loadDataSeparated = async (filter = null) => {
            isLoading.value = true;
            try {
                dataSourceNaikPangkatListSeparated.value.filter(filter);
                // Reload the DataSource with the new filter
                const result = await dataSourceNaikPangkatListSeparated.value.load();
                return result;
            } catch (error) {
                console.error("Error loading data:", error);
                throw error;
            } finally {
                isLoading.value = false;
            }
        };

        const state = ref(true);
        const onMuatButtonClick =()=>{
            state.value = false;
            dataSourceNaikPangkatList.value.reload();
        };

     

        const initialized = ()=>{     
            dataSourceNaikPangkatList.value.reload();
        };

        return {
           
            dataSourceNaikPangkatList,
            isLoading,
            onMuatButtonClick,
            initialized,
            state,
            loadData, 
            loadDataSeparated,
        }
    }
);